export const getNameInitials = (value: string) =>
  value
    .replace(/[^a-zA-Z-]+/g, '')
    .split('-')
    .map((partial) => partial[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('');
